import { observer } from 'mobx-react-lite';
import React from 'react';
import { bookingSummaryState } from '#/components/BookingSummaryPanel/BookingSummaryContext';
import InfoIcon from '@mui/icons-material/Info';
import IconButton from '@mui/material/IconButton';

const BookingSummaryToggle: React.FC = observer(function BookingSummaryToggleComponent() {
    return bookingSummaryState.mounted && bookingSummaryState.collapsable ? (
        <IconButton aria-label="Show summary" onClick={() => bookingSummaryState.toggle()} size="large">
            <InfoIcon />
        </IconButton>
    ) : null;
});

export default React.memo(BookingSummaryToggle);
